import axios from '@/api/axios'
import { resourceConstructor } from '@/api'

const constructFullUrl = resourceConstructor('doppler')

export default {
  list: ({ params }) =>
    axios.get(constructFullUrl('/user-notifications/'), { params }),
  markSeen: ({ data }) =>
    axios.put(constructFullUrl(`/user-notifications/`), data),
  saveFcmToken: ({ data }) =>
    axios.post(constructFullUrl('/users/device-tokens/'), data),
}
